import TimedoctorConfigPage from './TimedoctorConfigPage';

export default TimedoctorConfigPage;
